import { Link } from "@tanstack/react-router";
import { Bell01 } from "@untitledui/icons";
import { formatUnreadBadge } from "./notification-display";
import { useNotificationCounts } from "./use-notifications";
import type { PageTarget } from "@/components/page-back-button";
import { useUserContext } from "@/components/user-context";

export function NotificationBell({ from }: { from: PageTarget }) {
  const { orgId } = useUserContext();
  const { unreadCount } = useNotificationCounts();

  if (!orgId) {
    return null;
  }

  const badge = formatUnreadBadge(unreadCount);

  return (
    <Link
      to="/notifications"
      state={{ returnTo: from.url, returnLabel: from.label }}
      aria-label={
        unreadCount > 0 ? `Notifications, ${unreadCount} unread` : "Notifications"
      }
      className="relative cursor-pointer rounded-lg p-1 outline-focus-ring hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2"
    >
      <Bell01 className="size-5 text-fg-quaternary" />
      {badge && (
        <span className="absolute -right-0.5 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-medium text-white">
          {badge}
        </span>
      )}
    </Link>
  );
}